import { Outlet } from "react-router-dom";

export default function UserOnline() {
  return <Outlet />;
}
